import { createContext, useContext } from "react";
const OrgAdminClientContext = createContext(null);
export const OrgAdminClientProvider = OrgAdminClientContext.Provider;
export function useOrgAdminClient() {
    const client = useContext(OrgAdminClientContext);
    if (!client) {
        throw new Error("useOrgAdminClient must be used within OrgAdminClientProvider");
    }
    return client;
}
//# sourceMappingURL=useOrgAdminClient.js.map